'use strict';
import { isiOs, isIE, isChrome, isFirefox, isSafari } from './plugins/browser-checks';

window.viewport = function() {
    let e = window,
        a = 'inner';

    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

jQuery(() => {
    // global functionality goes here
    const $body = $('body'),
          $masthead = $('.masthead');

    $body.addClass('jsenabled');

    if(isiOs()) $body.addClass('browser-ios');
    if(isIE()) $body.addClass('browser-ie');
    if(isChrome()) $body.addClass('browser-chrome');
    if(isFirefox()) $body.addClass('browser-firefox');
    if(isSafari()) $body.addClass('browser-safari');

    // prevent disabled buttons to execute default actions
    $('.btn--disabled').on('click', function(e) {
        e.preventDefault();
    });

    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('.section__background-video').hide();
    }

    // load extra JS parts
    require('./modules/tooltips');
    require('./modules/gravity-forms');
    require('./modules/gtm-events');
    require('./modules/smooth-scroll-to');
    require('./modules/scroll-to-next-section');
    require('./modules/sliders');
    require('./modules/background-video');
    require('./modules/missing-title');
    require('./modules/insert-icons');
    require('./modules/menu');
    require('./modules/expandable-items');
    require('./modules/sticky-masthead');
    require('./modules/fancybox');
    require('./modules/tabs');
});
